export default __webpack_public_path__ + "static/media/027-gas-mask.37805635.png";